import { Injectable } from '@angular/core';
import { config } from '../config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  config = config;
  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };
  
  constructor(
    private http: HttpClient
  ) { }

  saveHolidayMaster(requestObject) {
    let URL = environment.URL + this.config.URL.saveHolidayMaster;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }
  uploadHolidayMaster(file: File) {
    let URL = environment.URL + this.config.URL.uploadHolidayMaster;
    let fileOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('token')
            })
    };
    const formData: FormData = new FormData();
    formData.append('file', file);
    console.log(formData instanceof FormData);
    return this.http.post(URL, formData);
  }

  getHolidayMaster(requestObject) {
    let URL = environment.URL + this.config.URL.getHolidayMaster;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }
}
